(function () {
  const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
  viewTransitionRenderBlocker?.remove();
})();
